import {DateObject} from "react-multi-date-picker";


const useManager = () => {

  /**
   * Create an array with a range of date items; one for every day.
   *
   * @param dates
   * @returns {*[]}
   */
  const createDateRange = (dates) => {
    // Validate input
    if (dates.length !== 2 || !(dates[0] instanceof DateObject) || !(dates[1] instanceof DateObject)) {
      return [];
    }

    const startDate = dates[0];
    const endDate = dates[1];
    const dateRange = [];

    // Ensure the start date is before the end date
    if (startDate > endDate) {
      return [];
    }

    let currentDate = new DateObject(startDate);

    // Generate range
    while (currentDate <= endDate) {
      dateRange.push(new DateObject(currentDate));
      currentDate = currentDate.add(1, "days");
    }

    return dateRange;
  }

  return {
    createDateRange
  }
}

export default useManager